import abl from '../../abl';
import GoogleSheetProcessor from './google_sheet_processor';

const GoogleAPI = abl.createClass({
	initialize: function(props) {
    props = props || {};
    this.apiKey = props.apiKey || 'AIzaSyDZx1er56QwGTn7KB-E-QQRxvHE832jCII';
    this.clientId = props.clientId || '55358074609-tlve91j1j6eje2j7vjdr77a8hthl226m.apps.googleusercontent.com';
    this.scopes = props.scopes || ['https://www.googleapis.com/auth/spreadsheets', 'https://www.googleapis.com/auth/drive.metadata.readonly'];
    this.sheetsUrl = props.sheetsUrl || 'https://sheets.googleapis.com/$discovery/rest?version=v4';
    this.driveUrl = props.driveUrl || 'https://www.googleapis.com/auth/drive.readonly'
    this.authenticated = false;
    this.clientCount = this.scopes.length;
    this.initialized = false;
    this.authCallbacks = [];
    this.gapi = this.gapi || window['gapi'];
    this.gapi.load('client:auth2', () => this._initClient());
	},

	authenticate: function(callback) {
    this.authCallbacks.push(callback);
    if(this.initialized) {
      callback(this.authenticated);
    }
  },

  signIn: function() {
    this.gapi.auth2.getAuthInstance().signIn();
  },

  getFiles: function(props) {
    return this.gapi.client.drive.files.list({
      'pageSize': 20,
      'corpus': 'user',
      'spaces': 'drive',
      'q': "'" + props.term + "' in parents and mimeType != 'application/vnd.google-apps.folder' and trashed = false",
      'orderyBy': 'createdTime',
      'fields': "nextPageToken, files(id, name, capabilities(canEdit))"
    });
  },

  getSheet: function(props) {
    return this.gapi.client.sheets.spreadsheets.get({
      spreadsheetId: props.spreadsheetId,
      ranges: props.ranges,
      fields: 'spreadsheetId,properties.title,sheets(properties,data.rowData.values(formattedValue,effectiveFormat(backgroundColor)))'
    }).then(
      response => {
        let processor = new GoogleSheetProcessor(response.result, props.version);
        return processor.toJSON()
      },
      err => {
        return err;
      }
    );
  },

  updateSheet: function(props) {
    return this.gapi.client.sheets.spreadsheets.values.update({
      spreadsheetId: props.spreadsheetId,
      range: props.range,
      valueInputOption: 'USER_ENTERED',
      majorDimension: 'COLUMNS',
      values: [
        [props.value]
      ]
    });
  },

  batchUpdateSheet: function(props) {
    return this.gapi.client.sheets.spreadsheets.values.batchUpdate({
      spreadsheetId: props.spreadsheetId,
      valueInputOption: 'USER_ENTERED',
      data: props.data
    });
  },

  _initClient: function() {
    this.gapi.auth2.init({
      client_id: this.clientId, 
      scope: this.scopes.join(' ')}
    )
    .then(() =>  {
      let auth2 = this.gapi.auth2.getAuthInstance();
      auth2.isSignedIn.listen(this._handleAuthChange.bind(this));
      this._initDrive(auth2);
      this._initSheets(auth2);
    });
  },

  _initSheets: function(auth2) {
    this.gapi.client.load(this.sheetsUrl).then(() => {
      this.authenticated = auth2.isSignedIn.get();
      this._setInitialized();
    });
  },

  _initDrive: function(auth2) {
    this.gapi.client.load('drive', 'v3', () => {
      this._setInitialized();
    });
  },

  _handleAuthChange: function(isAuthenticated) {
    this.authenticated = isAuthenticated;
    for(let i=0; i < this.authCallbacks.length; i++) {
      this.authCallbacks[i](isAuthenticated);
    }
  },

  _setInitialized: function() {
    this.clientCount--;
    if(this.clientCount === 0) {
      this.initialized = true;
      this._handleAuthChange(this.authenticated);
    }
  }
});

export default GoogleAPI;


/** WEBPACK FOOTER **
 ** ./src/js/clients/google/google_api.js
 **/